import { useSearchParams } from 'react-router-dom';
import { PublishersApi } from '../../apis/publishers.api';
import { useEffect, useState } from 'react';

export const useApiKey = () => {
	const [apiKey, setApiKey] = useState<string | null>(null);
	const [accountFullName, setAccountFullName] = useState<string | null>(null);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const [isSuccess, setIsSuccess] = useState<boolean>(false);
	const [error, setError] = useState<Error | null>(null);
	const [hasNoPermissions, setHasNoPermissions] = useState<boolean>(false);

	const [searchParams] = useSearchParams();
	const accountId = searchParams.get('accountId') || undefined;

	useEffect(() => {
		// Reset only loading/success/error state, keep old values to prevent flash
		setIsLoading(true);
		setIsSuccess(false);
		setError(null);
		setHasNoPermissions(false);

		if (accountId) {
			PublishersApi.apiKey({ id: accountId })
				.then(res => {
					setApiKey(res.apiKey);
					setAccountFullName(res.accountFullName);
					setIsSuccess(true);
					// Check if the API returned null/empty values indicating no permissions
					if (!res.apiKey || !res.accountFullName) {
						setHasNoPermissions(true);
					}
				})
				.catch(setError)
				.finally(() => setIsLoading(false));
		} else {
			setApiKey('YOUR_ACCOUNT_API_KEY');
			setAccountFullName('YOUR_ACCOUNT_NAME');
			setHasNoPermissions(false);
			setIsLoading(false);
		}
	}, [accountId]);

	return {
		apiKey: apiKey || 'YOUR_ACCOUNT_API_KEY',
		accountFullName: accountFullName || 'YOUR_ACCOUNT_NAME',
		isLoading,
		isSuccess,
		error,
		hasNoPermissions,
	};
};
